<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <h1 id="jump-to-header">{{heading || "Update"}}</h1>
    <actor-role-update :id="id"/>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ActorRoleUpdate from './ActorRoleUpdate.vue'

export default {
  components: {
    VuexBreadcrumb,
    ActorRoleUpdate
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>